export default "__VITE_ASSET__CjEzihCR__"